import _slicedToArray from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { HTTP_STATUS } from '../../../state/api/services/utils/constants';
import { getText, TEXT_KEY } from '../../../utils/localization';
import { normalizeTimestamp } from '../../../utils/TimestampManager';
import { PIGGY_BANK_INFO_SCREEN_TYPE, PIGGY_BANK_PROGRESS, PIGGY_BANK_RUNNING_STATUS } from '../constants';
import { getProgressIndex } from './helpers';
var progressConfig = [{
  image: 'PIGGY_BANK_PROGRESS_0',
  textKey: TEXT_KEY.PIGGY_BANK_BALLOON_SPIN
}, {
  image: 'PIGGY_BANK_PROGRESS_25',
  textKey: TEXT_KEY.PIGGY_BANK_BALLOON_SPIN
}, {
  image: 'PIGGY_BANK_PROGRESS_50',
  textKey: TEXT_KEY.PIGGY_BANK_BALLOON_SPIN
}, {
  image: 'PIGGY_BANK_PROGRESS_75',
  textKey: TEXT_KEY.PIGGY_BANK_BALLOON_NEARLY_FULL
}, {
  image: 'PIGGY_BANK_PROGRESS_100',
  textKey: TEXT_KEY.PIGGY_BANK_BALLOON_BREAK_ME
}];
var piggyBankBroken = function piggyBankBroken(piggyBankAssets) {
  return {
    renderPiggyImage: piggyBankAssets.PIGGY_BANK_BROKEN,
    renderBallonText: ''
  };
};
export var generatePiggyBankRendering = function generatePiggyBankRendering(piggyBankAssets, _ref) {
  var progress = _ref.progress,
    isBroken = _ref.isBroken;
  if (isBroken) return piggyBankBroken(piggyBankAssets);
  var progressItem = progressConfig[getProgressIndex(progress)];
  return {
    renderPiggyImage: piggyBankAssets[progressItem.image],
    renderBallonText: getText(progressItem.textKey)
  };
};
var generateInfoScreenPageOne = function generateInfoScreenPageOne(piggyBankAssets) {
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, PIGGY_BANK_INFO_SCREEN_TYPE.OFFER_COINS, piggyBankAssets.PIGGY_BANK_INFO_PAGE_1), PIGGY_BANK_INFO_SCREEN_TYPE.OFFER_COINS_LP, piggyBankAssets.PIGGY_BANK_INFO_PAGE_1_1), PIGGY_BANK_INFO_SCREEN_TYPE.OFFER_COINS_VIP, piggyBankAssets.PIGGY_BANK_INFO_PAGE_1_2), PIGGY_BANK_INFO_SCREEN_TYPE.OFFER_COINS_LP_VIP, piggyBankAssets.PIGGY_BANK_INFO_PAGE_1_3), "default", piggyBankAssets.PIGGY_BANK_INFO_PAGE_1);
};
export var generatePiggyBankInfoRendering = function generatePiggyBankInfoRendering(piggyBankAssets) {
  var infoScreenType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
  return [generateInfoScreenPageOne(piggyBankAssets)[infoScreenType], piggyBankAssets.PIGGY_BANK_INFO_PAGE_2];
};
export var generatePiggyBankIcon = function generatePiggyBankIcon(piggyBankSelector, piggyBankAssets) {
  var _data$piggyBankFeatur, _data$piggyBankFeatur2, _data$piggyBankFeatur3, _data$piggyBankFeatur4, _data$piggyBankFeatur5;
  var _ref3 = piggyBankSelector !== null && piggyBankSelector !== void 0 ? piggyBankSelector : {},
    data = _ref3.data,
    error = _ref3.error;
  var piggyBankSetup = data === null || data === void 0 || (_data$piggyBankFeatur = data.piggyBankFeatureState) === null || _data$piggyBankFeatur === void 0 ? void 0 : _data$piggyBankFeatur.piggyBankSetup;
  var runningStatus = data === null || data === void 0 || (_data$piggyBankFeatur2 = data.piggyBankFeatureState) === null || _data$piggyBankFeatur2 === void 0 || (_data$piggyBankFeatur2 = _data$piggyBankFeatur2.piggyBankSetup) === null || _data$piggyBankFeatur2 === void 0 ? void 0 : _data$piggyBankFeatur2.piggyBankRunningStatus;
  var progress = data === null || data === void 0 || (_data$piggyBankFeatur3 = data.piggyBankFeatureState) === null || _data$piggyBankFeatur3 === void 0 || (_data$piggyBankFeatur3 = _data$piggyBankFeatur3.breakPackage) === null || _data$piggyBankFeatur3 === void 0 ? void 0 : _data$piggyBankFeatur3.progress;
  var coolDownTimestamp = (_data$piggyBankFeatur4 = data === null || data === void 0 || (_data$piggyBankFeatur5 = data.piggyBankFeatureState) === null || _data$piggyBankFeatur5 === void 0 ? void 0 : _data$piggyBankFeatur5.coolDownTimestamp) !== null && _data$piggyBankFeatur4 !== void 0 ? _data$piggyBankFeatur4 : 0;
  var elements = {
    NOT_FOUND: {
      icon: null,
      tooltipText: null
    },
    MAINTENANCE: {
      icon: piggyBankAssets.PIGGY_BANK_ICON_MAINTENANCE,
      tooltipText: TEXT_KEY.UNDER_MAINTENANCE
    },
    COMING_SOON: {
      icon: piggyBankAssets.PIGGY_BANK_ICON_COMING_SOON,
      tooltipText: TEXT_KEY.COMING_SOON
    },
    FULL: {
      icon: piggyBankAssets.PIGGY_BANK_ICON_FULL,
      tooltipText: null
    },
    REST: {
      icon: piggyBankAssets.PIGGY_BANK_ICON_COMING_SOON,
      tooltipText: TEXT_KEY.PIGGY_BANK_REST
    },
    DEFAULT: {
      icon: piggyBankAssets.PIGGY_BANK_ICON_REGULAR,
      tooltipText: null
    }
  };
  if ((error === null || error === void 0 ? void 0 : error.status) === HTTP_STATUS.NOT_FOUND || (error === null || error === void 0 ? void 0 : error.status) === HTTP_STATUS.CORS_ERROR) return elements.NOT_FOUND;
  var conditions = [[(error === null || error === void 0 ? void 0 : error.status) === HTTP_STATUS.INTERNAL_SERVER_ERROR, elements.MAINTENANCE], [piggyBankSetup === null || normalizeTimestamp(coolDownTimestamp) > Date.now(), elements.REST], [runningStatus === PIGGY_BANK_RUNNING_STATUS.PAUSED, elements.MAINTENANCE], [runningStatus === PIGGY_BANK_RUNNING_STATUS.PENDING, elements.COMING_SOON], [progress === PIGGY_BANK_PROGRESS.FULL, elements.FULL]];
  var match = conditions.find(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 1),
      c = _ref5[0];
    return c;
  });
  return {
    piggyBankIcon: (match === null || match === void 0 ? void 0 : match[1].icon) || elements.DEFAULT.icon,
    tooltipText: getText(match === null || match === void 0 ? void 0 : match[1].tooltipText) || null,
    disabledAnimation: !!match
  };
};